export default "__VITE_ASSET__BghaPfuM__"